import JSON5 from "json5";
//Themes first - an environment resolves its theme out of the registry this fills
import "./themes/themes";
import "./env/innogy-charge/InnogyChargeEnv";
import "./env/polyfazer/PolyfazerEnv";
import "./env/polyfazer-dev/DevPolyfazerEnv";
import "./env/polyfazer-remote/RemotePolyfazerEnv";
import "./env/innogy-charge-dev/InnogyChargeDevEnv";
import "./env/altego/AlteGoEnv";
import "./env/altego-dev/AlteGoDevEnv";

//Apply app theme
document.documentElement.setAttribute("theme", localStorage.getItem("theme") || (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? "dark" : "light"));

const envs = window.environments;

function resolveEnvFromID(id) {
	if(process.env.NODE_ENV == "production") return;

	return Object.values(envs).find(env => env.environmentID == id);
}

/**
 * Resolve env from hostname
 * ---
 * Matches the host the app is served from against every environment's `hostnames` list in
 * envs.json. This is the only selection that works in a production build - `resolveEnvFromID`
 * bails out there - so a tenant is bound to its own domain rather than to being first in the
 * configuration, and one artifact with one envs.json serves all of them.
 *
 * An environment that declares no hostnames is never matched here and keeps falling back to the
 * first-entry behaviour, so nothing changes for the environments that predate this.
 */
function resolveEnvFromHostname() {
	const hostname = window.location.hostname.toLowerCase();

	return Object.values(envs).find(env => env.hostnames.some(candidate => candidate.toLowerCase() == hostname));
}

async function readJsonConfiguration() {
	const file = await fetch(`/env/envs.json`);
	const text = await file.text();
	return JSON5.parse(text);
}

readJsonConfiguration().then((configuration) => {
	const configurationIDs = Object.keys(configuration);
	configurationIDs.forEach(id => {
		if(window.environments[id]) {
			window.environments[id].dataFromJson = configuration[id];
		}
	});

	const env = resolveEnvFromID(localStorage.getItem("env")) || resolveEnvFromHostname() || window.environments[configurationIDs[0]];

	/**
	 * @type {EnvBase}
	 */
	window.activeEnvironment = env;

	env.apply();

	//Load polyfazer-app as last!
	import("./elements/polyfazer-app");
});

